import Select from "./Select";
import SelectMobile from "./SelectMobile";

export { Select, SelectMobile };

export default Select;
